//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showSpeechBubble1: true,
            showSpeechBubble2: false,
            answers: [
                {
                    label: this.$lang.get('w1d1.game4.water'),
                    correct: true,
                    clicked: false
                },
                {
                    label: this.$lang.get('w1d1.game4.bread'),
                    correct: false,
                    clicked: false
                },
                {
                    label: this.$lang.get('w1d1.game4.cold'),
                    correct: false,
                    clicked: false
                },
                {
                    label: this.$lang.get('w1d1.game4.nutrients'),
                    correct: true,
                    clicked: false
                },
                {
                    label: this.$lang.get('w1d1.game4.snow'),
                    correct: false,
                    clicked: false
                },
                {
                    label: this.$lang.get('w1d1.game4.light'),
                    correct: true,
                    clicked: false
                },
                {
                    label: this.$lang.get('w1d1.game4.air'),
                    correct: true,
                    clicked: false
                }
            ]
        };
    },

    computed: {
        result () {
            let numCorrect = this.answers.filter(answer => answer.correct && answer.clicked).length;
            let numTotalCorrect = this.answers.filter(answer => answer.correct).length;
            let numWrong = this.answers.filter(answer => !answer.correct && answer.clicked).length;

            return this.$game.getMultipleChoiceResult(numCorrect, numTotalCorrect, numWrong);
        }
    }
};
